import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import { FAQSchema, BreadcrumbSchema } from '../components/StructuredData';

const FAQPage: React.FC = () => {
  const faqs = [
    {
      question: "Wie spiele ich die Videos ab?",
      answer: "Klicken Sie auf das jeweilige Modul, um es zu öffnen. Das Video startet automatisch. Sie können es mit den Standard-Videobedienelementen steuern (Play/Pause, Vollbild, etc.)."
    },
    {
      question: "Wie komme ich zum nächsten Kapitel?",
      answer: "Um zum nächsten Kapitel zu gelangen, müssen Sie das aktuelle Modul als abgeschlossen markieren. Setzen Sie dazu den Haken bei 'Modul abgeschlossen' am Ende des Moduls. Das nächste Modul wird dann automatisch freigeschaltet."
    },
    {
      question: "Wann kann ich die Abschlussprüfung starten?",
      answer: "Die Abschlussprüfung wird freigeschaltet, sobald Sie alle Module erfolgreich abgeschlossen haben. Sie erkennen dies an der grünen Erfolgsmeldung am Ende der Modulliste."
    },
    {
      question: "Was passiert, wenn ich die Prüfung nicht bestehe?",
      answer: "Keine Sorge! Sie können die Prüfung beliebig oft wiederholen. Wir empfehlen, die Module noch einmal durchzugehen und sich Notizen zu den wichtigsten Punkten zu machen."
    },
    {
      question: "Wie erhalte ich mein Zertifikat?",
      answer: "Nach erfolgreichem Bestehen der Prüfung (mindestens 75%) können Sie Ihr Zertifikat direkt herunterladen. Optional können Sie es sich auch per E-Mail zusenden lassen."
    },
    {
      question: "Wie lange habe ich Zugriff auf den Kurs?",
      answer: "Nach erfolgreichem Bestehen der Prüfung haben Sie noch 14 Tage lang Zugriff auf alle Kursinhalte. In dieser Zeit können Sie die Materialien weiterhin einsehen und herunterladen."
    }
  ];

  return (
    <>
      <SEOHead
        title="Häufig gestellte Fragen (FAQ)"
        description="Antworten auf häufig gestellte Fragen zum EU AI Act Online-Kurs: Videos abspielen, Kapitel wechseln, Prüfung starten und Zertifikat erhalten."
        keywords={['FAQ', 'Häufige Fragen', 'Hilfe', 'Support', 'Kurs-Anleitung', 'EU AI Act Kurs']}
        canonicalUrl="/faq"
      />
      <FAQSchema faqs={faqs} />
      <BreadcrumbSchema items={[
        { name: 'Startseite', url: '/' },
        { name: 'FAQ', url: '/faq' }
      ]} />
      <div className="min-h-screen bg-gray-50 py-16">
        <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-4 mb-8">
            <Link 
              to="/kurszugang"
              className="text-gray-600 hover:text-gray-800 transition-colors"
            >
              <ArrowLeft className="h-6 w-6" />
            </Link>
            <h1 className="text-3xl font-bold text-gray-800">Häufig gestellte Fragen</h1>
          </div>

          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div 
                key={index}
                className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
              >
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {faq.question}
                </h3>
                <p className="text-gray-600">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default FAQPage;